// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__VfYI1","title":"Images90_title__3aQq5","images":"Images90_images__2Zr-S"};